<template>
    <div id="app">
        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>
        <!--<index></index>-->
    </div>
</template>

<script>
import Index from "@/view/index";
import bus from "./libs/bus";
export default {
    data() {
        return {};
    },
    name: "App",
    components: { Index },
    mounted() {
        console.log(this.$route);
    },

    methods: {},
};
</script>

<style lang="stylus" rel="stylesheet/stylus">
@import './libs/resetElement.styl';
@import './assets/css/variables.styl';
html, body {
    width: 100%;
    height: 100%;

    #app {
        width: 100%;
        height: 100%;
        overflow: hidden;
        min-width: 1200px;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue